const actions = {
  GET_DATA_WAREHOUSES: 'GET_DATA_WAREHOUSES',
  SET_DATA_WAREHOUSES: 'SET_DATA_WAREHOUSES',
  GET_DATA_BEGIN_WAREHOUSES: 'GET_DATA_BEGIN_WAREHOUSES',
  GET_DATA_FINISH_WAREHOUSES: 'GET_DATA_FINISH_WAREHOUSES',

  GET_DATA_INVENTORIES: 'GET_DATA_INVENTORIES',
  SET_DATA_INVENTORIES: 'SET_DATA_INVENTORIES',
  GET_DATA_BEGIN_INVENTORIES: 'GET_DATA_BEGIN_INVENTORIES',
  GET_DATA_FINISH_INVENTORIES: 'GET_DATA_FINISH_INVENTORIES',

  GET_DATA_PRODUCTS_BY_WAREHOUSE: 'GET_DATA_PRODUCTS_BY_WAREHOUSE',
  SET_DATA_PRODUCTS_BY_WAREHOUSE: 'SET_DATA_PRODUCTS_BY_WAREHOUSE',
  GET_DATA_BEGIN_PRODUCTS_BY_WAREHOUSE: 'GET_DATA_BEGIN_PRODUCTS_BY_WAREHOUSE',
  GET_DATA_FINISH_PRODUCTS_BY_WAREHOUSE: 'GET_DATA_FINISH_PRODUCTS_BY_WAREHOUSE',

  setWarehouses: (data: any) => ({
    type: actions.SET_DATA_WAREHOUSES,
    data,
  }),
  getWarehousesBegin: () => ({ 
    type: actions.GET_DATA_BEGIN_WAREHOUSES 
  }),
  getWarehousesFinish: () => ({ 
    type: actions.GET_DATA_FINISH_WAREHOUSES 
  }),

  setInventories: (data: any) => ({
    type: actions.SET_DATA_INVENTORIES,
    data,
  }),
  getInventoriesBegin: () => ({ 
    type: actions.GET_DATA_BEGIN_INVENTORIES 
  }),
  getInventoriesFinish: () => ({ 
    type: actions.GET_DATA_FINISH_INVENTORIES 
  }),

  setProductsByWarehouse: (data: any) => ({
    type: actions.SET_DATA_PRODUCTS_BY_WAREHOUSE,
    data,
  }),
  getProductsByWarehouseBegin: () => ({
    type: actions.GET_DATA_BEGIN_PRODUCTS_BY_WAREHOUSE
  }),
  getProductsByWarehouseFinish: () => ({
    type: actions.GET_DATA_FINISH_PRODUCTS_BY_WAREHOUSE
  }),


  RESERVE_PRODUCT_BEGIN: 'RESERVE_PRODUCT_BEGIN',
  RESERVE_PRODUCT_SUCCESS: 'RESERVE_PRODUCT_SUCCESS',
  RESERVE_PRODUCT_ERROR: 'RESERVE_PRODUCT_ERROR',

  reserveProductBegin: () => ({
    type: actions.RESERVE_PRODUCT_BEGIN
  }),
  reserveProductSuccess: (data: any) => ({
    type: actions.RESERVE_PRODUCT_SUCCESS,
    data
  }),
  reserveProductError: (error: any) => ({
    type: actions.RESERVE_PRODUCT_ERROR,
    error
  }),

  RELEASE_PRODUCT_BEGIN: 'RELEASE_PRODUCT_BEGIN',
  RELEASE_PRODUCT_SUCCESS: 'RELEASE_PRODUCT_SUCCESS',
  RELEASE_PRODUCT_ERROR: 'RELEASE_PRODUCT_ERROR',

  releaseProductBegin: () => ({ type: actions.RELEASE_PRODUCT_BEGIN }),
  releaseProductSuccess: (data: any) => ({ type: actions.RELEASE_PRODUCT_SUCCESS, data }),
  releaseProductError: (error: any) => ({ type: actions.RELEASE_PRODUCT_ERROR, error }),

  UPDATE_RESERVATION_BEGIN: 'UPDATE_RESERVATION_BEGIN',
  UPDATE_RESERVATION_SUCCESS: 'UPDATE_RESERVATION_SUCCESS',
  UPDATE_RESERVATION_ERROR: 'UPDATE_RESERVATION_ERROR',

  updateReservationBegin: () => ({ type: actions.UPDATE_RESERVATION_BEGIN }),
  updateReservationSuccess: (data: any) => ({ type: actions.UPDATE_RESERVATION_SUCCESS, data }),
  updateReservationError: (error: any) => ({ type: actions.UPDATE_RESERVATION_ERROR, error }),

};

export default actions;
